export default "__VITE_ASSET__CeV71Ovr__"